import { useEffect } from 'react';
import { usePersistentStore } from 'store/persistent';
import useSourceInstitutions from 'hooks/use-source-institutions';

export default function useRecentSourceInstitutions(): {
  recentSourceInstitutions: string[];
  addRecentSourceInstitution: (sourceInstitutionID: string) => void;
  // eslint-disable-next-line indent
} {
  const sourceInstitutions = useSourceInstitutions();
  const recentSourceInstitutions = usePersistentStore((state) => state.recentInstitutions);
  const setRecentSourceInstitutions = usePersistentStore((state) => state.setRecentInstitutions);
  const addRecentSourceInstitution = usePersistentStore((state) => state.addRecentInstitution);

  // Clear out any invalid recent IDs due to stale reference data
  useEffect(() => {
    if (sourceInstitutions.size === 0) {
      return;
    }
    const validRecentInstitutionsIDs = recentSourceInstitutions.filter((institutionID) =>
      sourceInstitutions.has(institutionID),
    );
    if (validRecentInstitutionsIDs.length !== recentSourceInstitutions.length) {
      setRecentSourceInstitutions(validRecentInstitutionsIDs);
    }
  }, [recentSourceInstitutions, setRecentSourceInstitutions, sourceInstitutions]);

  return { recentSourceInstitutions, addRecentSourceInstitution };
}
